var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27344 0C3.26284 0 0 3.26284 0 7.27344C0 8.5572 0.33918 9.81933 0.980838 10.9233C1.13112 11.1818 1.29712 11.4308 1.47792 11.6689L6.95741 19H7.58942L13.069 11.6689C13.2497 11.4308 13.4157 11.1818 13.566 10.9234C14.2077 9.81933 14.5469 8.5572 14.5469 7.27344C14.5469 3.26284 11.284 0 7.27344 0ZM7.27344 9.68555C5.9434 9.68555 4.86133 8.60347 4.86133 7.27344C4.86133 5.9434 5.9434 4.86133 7.27344 4.86133C8.60347 4.86133 9.68555 5.9434 9.68555 7.27344C9.68555 8.60347 8.60347 9.68555 7.27344 9.68555Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconAddress);
export default __webpack_public_path__ + "static/media/location-icon-address.3f3a9102fd36b1f063d3da61f6c177da.svg";
export { ForwardRef as ReactComponent };